const googleApiKey = "AIzaSyD-nGKDeN0HRp9E1sH-BpHAr-de7hoc870";

const googleConfig = {
  googleApiKey,
};

export default googleConfig;
